import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { LoadingIndicator } from 'sharedComponents';
import logger from 'helpers/logger';
import { notify } from 'sharedComponents/GeneralNotification';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import './style.scss';
import { routes } from 'routes';
import UserCapabilityHelper from 'helpers/userCapabilityHelper';
import { removeReturnUrl } from './helpers';


const TokenExchangeComponent = ({ model: { userManager, redirectUrl, userCapabilities }, actions: { loadUserInfo, getUserCapabilities } }) => {
    const [tokensRetrieved, setTokensRetrieved] = useState(false);
    const [loadingVisible, setLoadingVisible] = useState(true);
    const history = useHistory();
    const capabilities = new UserCapabilityHelper(userCapabilities);
    const isREC = capabilities.hasHomePageRecCapability(); /* FALSE FOR LSU AND END USER | TRUE FOR REC USER */
    const isLSU = capabilities.hasFleetOverviewCapability() || capabilities.hasHomePageCapability();

    useEffect(() => {
        if (tokensRetrieved && userCapabilities?.loadingStatus === apiCallStatus.SUCCESS) {
            if (redirectUrl && redirectUrl !== 'null') {
                removeReturnUrl();
                history.push(redirectUrl);
            } else {
                if (isREC) {
                    return history.push(routes.FleetDashboard);
                }
                if (isLSU) {
                    return history.push(routes.FleetOverview);
                }
                history.push('/');
            }
        }
    }, [tokensRetrieved, userCapabilities]);

    const authenticationErrorNotify = (err) => {
        notify('An error has occurred while loading the user information, please come back later.', NOTIFICATION_TYPES.ERROR, true);
        logger.debug(err);
    };

    useEffect(() => {
        if (!tokensRetrieved && userManager) {
            userManager.signinRedirectCallback()
                .then((userCredentials) => {
                    userManager.storeUser(userCredentials);
                    loadUserInfo(
                        userCredentials,
                        setTokensRetrieved,
                        () => { setLoadingVisible(false); authenticationErrorNotify(); }
                    );
                    getUserCapabilities();
                });
        }
    }, [userManager]);


    return <div className='token-exchange'>
        {loadingVisible &&
            <LoadingIndicator text='Logging in...' />}
    </div>;
};

TokenExchangeComponent.propTypes = {
    model: PropTypes.shape({
        userManager: PropTypes.object,
        redirectUrl: PropTypes.string
    }),
    actions: PropTypes.shape({
        loadUserInfo: PropTypes.func
    })
};

export default TokenExchangeComponent;
